@if (!showSidebar()) {
  <div class="p-0 show-sidebar-container"
       [ngClass]="{ 'd-none': showSidebar(),
                           'col-auto': !showSidebar()}">
    <button class="toggle-sidebar btn border-left-0"
            (click)="toggleSidebar()">
      <div class="d-inline-flex">
        <ucs-icon [size]="24" [shape]="'search'" class="sidebar-icon"></ucs-icon>
        <ucs-icon [size]="16" [shape]="'double_angle_right'" class="blue"></ucs-icon>
      </div>
    </button>
  </div>
} @else {
  <div (click)="toggleSidebar()" (keydown)="toggleSidebar()" class="filter-backdrop"></div>

  <div class="container-fluid sidebar pb-2">
    <!--toggle-button-sidebar-->
    <div class="row box mb-0 pt-2 sticky-top position-relative-md bg-white">
      <div class="col-12 mt-2 mb-2">
        <button (click)="toggleSidebar()"
                class="button-borderless w-100 d-flex justify-content-between icon-height">
          {{ 'search-filter.hide' | translate }}
          <div class="d-inline-flex">
            <ucs-icon [class]="'blue'" [shape]="'search'" [size]="24"></ucs-icon>
            <ucs-icon [shape]="'double_angle_left'" [size]="16" class="me-1 blue"></ucs-icon>
          </div>
        </button>
      </div>
    </div>
    <ng-content/>
  </div>
}